import { createContext, useContext, useReducer } from 'react';
import ajaxConfig from '../util/remote/ajaxConfig';

const initialState = { 
    userRoles: null,
    userListing: null,
    wifiPlans: null,
    selectedWifiPlan: null,
    routers: null,
    selectedRouter: null,
    collectionWallet: null,
    settingsMenu: null,
    portalPlans: null
};

const reducer = (state, action) => {
    switch (action.type) {
      case 'CLEAR':
        return { initialState};  // Reset state completely
      default:
        return {...state, [action.type]: action.payload};
    }
  };


const ConfigContext = createContext();

export const ConfigProvider = ({children}) =>{
  const [state, dispatch] = useReducer(reducer, initialState);

  const getUserRoles = async (refresh) => {
    if(!refresh && Array.isArray(state.userRoles)){
      return
    }
    const server_response  = await ajaxConfig.fetchRoles();
    if(server_response.status === "OK"){
        dispatch({ type: 'userRoles', payload: server_response.details });
    }else{
      dispatch({ type: 'userRoles', payload: '404' });

    }
  };

  const getUsers = async (refresh) => {
    if(!refresh && Array.isArray(state.userListing)){
      return
    }
    if(refresh){
      dispatch({ type: 'userListing', payload: null });
    }
    const server_response  = await ajaxConfig.fetchUsers();
    if(server_response.status === "OK"){
        dispatch({ type: 'userListing', payload: server_response.details });
    }else{
      dispatch({ type: 'userListing', payload: '404' });

    }
  };

  const getWifiPlans = async (refresh) => {
    if(!refresh && Array.isArray(state.wifiPlans)){
      return
    }
    if(refresh){
      dispatch({ type: 'wifiPlans', payload: null });
    }
    const server_response  = await ajaxConfig.fetchWifiPlans();
    if(server_response.status === "OK"){
        dispatch({ type: 'wifiPlans', payload: server_response.details });
    }else{
      dispatch({ type: 'wifiPlans', payload: '404' });

    }
  };

  const selectWifiPlan = (plan) => {
    dispatch({ type: 'selectedWifiPlan', payload: plan });
  };

  const selectRouter = (router) => {
    dispatch({ type: 'selectedRouter', payload: router });
  };

  const getRouters = async (refresh) => {
    if(!refresh && Array.isArray(state.routerListing)){
      return
    }
    const server_response  = await ajaxConfig.fetchRouters();
    if(server_response.status === "OK"){
        dispatch({ type: 'routers', payload: server_response.details });
    }else{
      dispatch({ type: 'routers', payload: '404' });

    }
  };

  const getWallet = async (refresh) => {
    if(!refresh && state.collectionWallet) {
      return
    }
    const server_response  = await ajaxConfig.getWallet();
    if(server_response.status === "OK"){
        dispatch({ type: 'collectionWallet', payload: server_response.details });
    }else{
      dispatch({ type: 'collectionWallet', payload: '404' });

    }
  };

  const getSettingsMenu = async (refresh) => {
    if(!refresh && state.settingsMenu) {
      return
    }
    const server_response  = await ajaxConfig.readSettings();
    if(server_response.status === "OK"){
        dispatch({ type: 'settingsMenu', payload: server_response.details });
    }
  };

  const getPortalPlans = async (refresh) => {
    if(!refresh && Array.isArray(state.portalPlans)){
      return
    }
    const server_response  = await ajaxConfig.fetchPortalPlans();
    if(server_response.status === "OK"){
        dispatch({ type: 'portalPlans', payload: server_response.details });
    }else{
      dispatch({ type: 'portalPlans', payload: '404' });
    }
  };

  return(
    <ConfigContext.Provider value={{
      ...state, 
      dispatch, 
        getUserRoles,
        getUsers,
        getWifiPlans,
        selectWifiPlan,
        getRouters,
        selectRouter,
        getWallet,
        getSettingsMenu,
        getPortalPlans
      }}>
      {children}
    </ConfigContext.Provider>
  )

}

export const useConfig = ()=>useContext(ConfigContext);

